import { render, staticRenderFns } from "./groupIncome.vue?vue&type=template&id=36281e4f&scoped=true&"
import script from "./groupIncome.vue?vue&type=script&lang=js&"
export * from "./groupIncome.vue?vue&type=script&lang=js&"
import style0 from "./groupIncome.vue?vue&type=style&index=0&id=36281e4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36281e4f",
  null
  
)

export default component.exports